<template>
    <div class="float-left">
        <b-button
        variant="success"
        @click="abrirModal()">
            Aprovar Conformidade Técnica
        </b-button>
        <conformidade-tecnica-form
            operacaoProp="A"
            :pleito="pleito"
            :mostrarModal="mostrarModal"
            :erros="erros"
            :dataServicos="dataServicos"
            @fechar="fecharModal()"
            @salvar="salvar($event)"
        ></conformidade-tecnica-form>
    </div>
</template>

<script>
import ConformidadeTecnicaForm from './ConformidadeTecnicaForm'

export default {
    components: {
        ConformidadeTecnicaForm
    },

    props: {
        pleito: {
            type: Object,
        },
        dataServicos: {
            type: Object
        },
    },

    data() {
        return {
            mostrarModal: false,
            erros: [],
        }
    },

    methods: {
        abrirModal() {
            this.mostrarModal = true
        },

        fecharModal() {
            this.mostrarModal = false
        },

        salvar(conformidadeTecnica){
            this.$store.dispatch('addRequest')
            let conformidadeTecnicaDto = {
                pleitoId : conformidadeTecnica.pleitoId,
                justificativa: conformidadeTecnica.justificativa,
            }
            
            // Detecta dinamicamente qual método usar baseado no serviço disponível
            let metodoAprovar = null
            if (this.dataServicos.aprovarConformidadeTecnicaUcic) {
                metodoAprovar = this.dataServicos.aprovarConformidadeTecnicaUcic(conformidadeTecnicaDto)
            } else if (this.dataServicos.aprovarConformidadeTecnica) {
                metodoAprovar = this.dataServicos.aprovarConformidadeTecnica(conformidadeTecnica.pleitoId)
            } else {
                this.$toast.error('Serviço de aprovação de conformidade técnica não disponível')
                this.$store.dispatch('removeRequest')
                this.fecharModal()
                return
            }
            
            metodoAprovar.then(response => {
                if (response) {
                    if (response.success) {
                        this.$toast.success(
                            'Conformidade Técnica aprovada com sucesso',
                            'OK',
                            this.$toastConfig.success)
                        this.$emit('atualizarLista')
                    } else {
                        this.erros = response.errors
                    }
                }
                this.$store.dispatch('removeRequest')
            })
            this.fecharModal()
        },
    }
}
</script>
